import { apiRequest } from 'api/apiRequest'

const sendMultipleSession = (data) =>
  apiRequest('/v1/session/sync', { session: {} }).post(data)

const sendSessionInfoBefore = (data) =>
  apiRequest('/v1/session/create', { session: {} }).post(data)

const sendSessionInfoAfter = (data) =>
  apiRequest('/v1/session/update', { session: {} }).put(data)

export const sessionApi = {
  sendMultipleSession,
  sendSessionInfoBefore,
  sendSessionInfoAfter,
}
